import { createAsyncThunk } from '@reduxjs/toolkit'
import apiClient from '../../../services/axois'
import { API_ROUTES } from '../../../utility/api.routes'
import { toast } from 'react-toastify'


export const createFaculty = createAsyncThunk('faculty/createFaculty', async ({formData,navigate}) => {
    try {
      const url = API_ROUTES.ADD_FACULTY.POST_FACULTY
      const response = await apiClient.post(url, formData)
      if(response?.data?.status){
        navigate('/faculty')
        toast.success(response.data.message, {
          className: 'custom-toast-success',
          progressStyle: { background: '#ffffff' },
        })
      }
    } catch (error) {
      toast.error(error.response.data.message)
      throw error
    }
  })

export const editFaculty = createAsyncThunk('faculty/editFaculty', async ({id, formData,navigate},{dispatch}) => {
  // const dispatch = useDispatch();
  const url = API_ROUTES.ADD_FACULTY.PUT_FACULTY(id)
    try {
      const response = await apiClient.put(url,formData)
      if(response?.data?.status){
            navigate('/faculty')
            toast.success(response.data.message, {
              className: 'custom-toast-success',
              progressStyle: { background: '#ffffff' },
            })
          }
    } catch (error) {
      toast.error(error.response.data.message)
      throw error
    }
  })

  export const getBillingInfo = createAsyncThunk('faculty/getAllBillingInfo', async (facultyId) => {
    try {
      const url = API_ROUTES.ADD_FACULTY.GET_FACULTY_BILLING_INFO(facultyId)
      const response = await apiClient.get(url)
      return response?.data?.result
    } catch (error) {
      toast.error(error.response.data.message)
      throw error
    }
  })

  export const getBank = createAsyncThunk('bank/getBank', async () => {
    try {
      const url = API_ROUTES.ADD_FACULTY.GET_BANK
      const response = await apiClient.get(url)
      return response?.data?.result 
    } catch (error) {
      toast.error(error.response.data.message)
      throw error
    }
  })